import { render, staticRenderFns } from "./SecurityService.vue?vue&type=template&id=0a42c121&scoped=true"
import script from "./SecurityService.vue?vue&type=script&lang=js"
export * from "./SecurityService.vue?vue&type=script&lang=js"
import style0 from "./SecurityService.vue?vue&type=style&index=0&id=0a42c121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42c121",
  null
  
)

export default component.exports